<template>
  <v-dialog width="auto" :title="'Mass Transfer'" :visible.sync="dialogVisible" :scrollbar="false" @opened="onOpened"
    @closed="onClosed">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="100px">
      <el-form-item prop="type" label="Select Type">
        <el-select v-model="form.type" filterable placeholder="Please select Type"  @change="changeType">
          <el-option label="vCE" value="vCE" :disabled="isDisabledvCE"></el-option>
          <el-option label="SE" value="SE" :disabled="isDisabledSECE"></el-option>
          <el-option label="CE" value="CE" :disabled="isDisabledSECE"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="userId" label="Select User">
        <el-select v-model="form.userId" filterable placeholder="Please select User" :loading="loading">
          <el-option v-for="(item, i) in mlList" :key="i" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="actions">
      <el-button type="primary" @click="onConfirm" :loading="saving">
        {{ saving ? "Saving" : "Save" }}
      </el-button>
      <el-button @click="onClosed">Cancel</el-button>
    </div>
  </v-dialog>
</template>

<script>
import { RoleCode } from "@/utils/role-constant";
export default {
  name: "TransferSEDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Array,
    type:String,
    pageType:String,
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      mlList: [],
      form: {
        userId: "",
        type:''
      },
      saving: false,
      formRules: {
        userId: [
          { required: true, message: "Please select User", trigger: "change" },
        ],
        type: [
          { required: true, message: "Please select Type", trigger: "change" },
        ]
      },
    };
  },
  computed: {
    role(){
      return this.$store.state.role;
    },
    isSupervisor(){
      return this.role == RoleCode.Supervisor
    },
    isMSL(){
      return this.role == RoleCode.ML
    },
    isvMSL(){
      return this.role == RoleCode.VMSL
    },
    isDisabledvCE(){
      return this.pageType == 'CommonHCPList' && this.isMSL
    },
    isDisabledSECE(){
      return this.pageType == 'CommonHCPList' && this.isvMSL
    }
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onOpened() {
      this.loading = true
      this.form.type = this.type
      if(this.isDisabledvCE){
        this.form.type = 'SE'
      }
      if(this.isDisabledSECE){
        this.form.type = 'vCE'
      }
      this.getMLList();
    },
    onClosed() {
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
      this.$emit("update:data", null);
    },
    changeType(){
      this.form.userId = null
      this.loading = true
      this.getMLList()
    },
    getMLList() {
      let api ="/se/mlList?type=transfer"
      api = this.form.type =='vCE'? '/se/vmlList?type=transfer':api
      if(this.pageType == 'CommonHCPList'){
        api =  this.form.type =='vCE'?'/se/commonHCPMLList?type=vCE':'/se/commonHCPMLList?type=SE'
      }
      this.axios.get(api).then(({ code, data }) => {
        if (code === 200) {
          this.loading = false
          this.mlList = Array.from(data, (i) => {
            return {
              value: i.UserID,
              label: i.Name,
            };
          });
          this.mlList =[
            {
              value: 'NA',
              label: 'NA',
            },
            ...this.mlList
          ]
          if (this.mlList.length > 0) {
              this.form.userId = this.mlList[0].value;
          }
        }
      })
      .catch(() => {
              this.loading = false;
            });
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.data || (this.data && this.data.length === 0)) {
            return;
          }
          this.$confirm(
            "Once transferred, all the records will be transferred too.",
            "Attention",
            {
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
            }
          )
            .then(() => {
              this.saving = true;
              this.axios
                .post("/se/transfer", {
                  type:this.form.type,
                  seId: this.data,
                  userId: this.form.userId=='NA'?'':this.form.userId,
                })
                .then(({ code, msg }) => {
                  if (code === 200) {
                    this.$message.success("Transfer HCP(s) successfully");
                    this.onClosed();
                    this.$emit("success");
                  } else {
                    this.$message.error(msg);
                  }
                  this.saving = false;
                });
            })
            .catch(() => {
              this.saving = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  margin-top: 20px;
  text-align: center;
}

::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding: 20px 40px 0px;
  }
}
</style>
